import { WORKER_MAIN_PROXY_PATH } from '@/lib/environment/config';
import { InfinexUserProvider } from '@infinex/user';

export const ConnectUserProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <InfinexUserProvider
      reloadOnSessionChange={true}
      wsUrl={`${WORKER_MAIN_PROXY_PATH}/v2/session/websocket`}
    >
      {children}
    </InfinexUserProvider>
  );
};
